const TEMPLATE_GROUP_TYPE_NAMES = {
  starringYouGif: "Starring You Gif",
  straightUpEcard: "Straight Up Ecard",
  starringYouEcard: "Starring You Ecard",
  starringYouClip: "Starring You Clip",
  starringYouVertical: "Starring You Vertical",
};

Object.freeze(TEMPLATE_GROUP_TYPE_NAMES);

export { TEMPLATE_GROUP_TYPE_NAMES };
